import { lazy, Suspense, useEffect, useState } from 'react';

import { PROD } from '@/utils/constants/common';
import { getCurrentEnv } from '@/utils/getCurrentEnv';

declare global {
    interface Window {
        toggleDevtools: () => void;
    }
}

const ReactQueryDevtoolsProduction = lazy(() =>
    import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
        default: d.ReactQueryDevtools,
    })),
);

export default function TanstackDevTools() {
    const env = getCurrentEnv() || PROD;
    const [showDevtools, setShowDevtools] = useState(false);

    useEffect(() => {
        if (env !== PROD) {
            window.toggleDevtools = () => setShowDevtools((old) => !old);
        }
    }, []);

    if (env !== PROD && showDevtools) {
        return (
            <Suspense fallback={null}>
                <ReactQueryDevtoolsProduction />
            </Suspense>
        );
    }
    return <></>;
}
